import { Paper } from '@mui/material'
import { ReactNode } from 'react'

export const SelectedAnswerWrapper = ({
  selected,
  children
}: {
  selected: boolean
  children: ReactNode
}) => {
  if (!selected) {
    return (
      <Paper
        sx={{
          bgcolor: 'transparent',
          p: 0.5,
          display: 'flex',
          flexDirection: 'column'
        }}
        elevation={0}>
        {children}
      </Paper>
    )
  }
  return (
    <Paper
      sx={{
        bgcolor: 'transparent',
        p: 0.5,
        display: 'flex',
        flexDirection: 'column'
      }}
      elevation={0}>
      {children}
    </Paper>
  )
}
